/* __next_internal_client_entry_do_not_use__ default auto */import { useEffect } from "react";
import { useLocale, useMessages } from "next-intl";
import { RenderImportModal } from "./GlobalPopup";
import { isIOS, isMobile } from "react-device-detect";
import { detectClientEnvironment, GenerateLink } from "@/util";
import { ReportDataInstance } from "@/lib/DataPort";
const ImportModal = () => {
  const locale = useLocale();
  const messages = useMessages();
  useEffect(() => {
    (async () => {
      const {
        canAccessInternet
      } = await detectClientEnvironment();
      if (isMobile && !isIOS && canAccessInternet) {
        void RenderImportModal({
          messages,
          locale,
          onOpen() {
            ReportDataInstance.clickOpenImportModal();
            window.open(GenerateLink("h5_seopopup"));
          },
          onClose() {
            ReportDataInstance.closeOpenImportModal();
          },
          beforeOpenModal() {
            ReportDataInstance.beforeOpenImportModal();
          }
        });
      }
    })();
  }, []);
  return null;
};
export default ImportModal;